var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-header"},[_c('h1',{staticClass:"h3"},[_vm._v(_vm._s(_vm.header))]),(_vm.info)?_c('p',{staticClass:"text-small text-grey"},[_vm._v(_vm._s(_vm.info))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }